import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaPrint } from "react-icons/fa";
import { toast } from "react-toastify";

const API_BASE = "https://nissi-india.com/api/closedVehicleRpt";

const toStr = (v) => String(v ?? "").trim();

export default function ClosedReportView_Print() {
  const navigate = useNavigate();
  const location = useLocation();

  const qs = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const vehicleId = toStr(qs.get("ClosedVehIdView"));

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, [location.search]);

  const load = async () => {
    try {
      if (!vehicleId) return toast.error("Vehicle id missing");

      setLoading(true);
      const { data } = await axios.get(`${API_BASE}/view`, {
        params: { vehicleId },
      });

      if (!data?.success) throw new Error(data?.message);
      setData(data.header || {});
    } catch (err) {
      toast.error(err.message || "Failed to load report");
    } finally {
      setLoading(false);
    }
  };

  const val = (key) => toStr(data[key]) || "";

  return (
    <div className="bg-white min-h-screen">
      <style>{`
        @page { size: A4 portrait; margin: 15mm; }
        @media print {
          .no-print { display: none !important; }
        }
      `}</style>

      {/* Top Action Bar */}
      <div className="no-print flex justify-between p-4 border-b">
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 border rounded flex items-center gap-2"
        >
          <FaArrowLeft /> Back
        </button>

        <button
          onClick={() => window.print()}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white rounded flex items-center gap-2"
        >
          <FaPrint /> Print
        </button>
      </div>

      {/* Print Area */}
      <div className="max-w-[850px] mx-auto p-6">

        <div className="border-2 border-black p-4">

          {/* Company Header */}
          <div className="border border-black p-3 flex">
            <div className="w-[120px] border border-black flex items-center justify-center text-xs font-bold text-center">
              UNDER<br/>CONSTRUCTION
            </div>

            <div className="flex-1 text-center">
              <div className="font-bold text-xl">Nissi Infotech</div>
              <div className="font-semibold">Nissi</div>
              <div className="font-semibold">CIVIL CONSTRUCTION</div>
              <div className="text-xs mt-1">
                3/42-12, Nagappa colony, kavundampalayam-641030, Tamil Nadu, India.
              </div>
              <div className="text-xs">
                Phone No : 9003744644 &nbsp;&nbsp;&nbsp;
                infracnsoft-implementation@nissiinfotech.in
              </div>
            </div>
          </div>

          {/* Title */}
          <div className="border border-black border-t-0 text-center font-bold py-2">
            Closed Vehicle
          </div>

          {/* Details Section */}
          <div className="border border-black border-t-0 p-4 text-sm">

            <div className="grid grid-cols-2 gap-10">

              {/* LEFT COLUMN */}
              <div className="space-y-2">
                <Field label="Equipment Name" value={val("vehicle_name")} />
                <Field label="Code" value={val("vehicle_code")} />
                <Field label="Reg No" value={val("regno")} />
                <Field label="Branch" value={val("BranchName")} />
                <Field label="Store" value={val("StoreName")} />
                <Field label="Equipment Model" value={val("vehicle_model")} />
                <Field label="Equipment Basis" value={val("basis")} />
                <Field label="Equipment Rent" value={val("rent")} />
                <Field label="Chq favname" value={val("chqfavname")} />
                <Field label="IC Expire" value={val("ic_expire")} />
                <Field label="FC Expire" value={val("fc_expire")} />
                <Field label="Admin Approved" value={val("adminapproved")} />
                <Field label="Valid From" value={val("validfrom")} />
                <Field label="Valid Upto" value={val("validupto")} />
              </div>

              {/* RIGHT COLUMN */}
              <div className="space-y-2">
                <Field label="Equipment Status" value="Closed" />
                <Field label="Equipment Type" value={val("vehType")} />
                <Field label="Total Hours" value={val("totalWhrs")} />
                <Field label="Total Kms" value={val("totalkms")} />
                <Field label="Address" value={val("address")} />
                <Field label="City" value={val("city")} />
                <Field label="Telephone No." value={val("telephone")} />
                <Field label="Owner's Name" value={val("ownername")} />
                <Field label="Contact Person" value={val("contactperson")} />
                <Field label="Mobile No." value={val("mobileno")} />
                <Field label="Mailing Address" value={val("mailingaddress")} />
                <Field label="Pancard Holder" value={val("pancardholder")} />
                <Field label="Pancard No." value={val("pancardno")} />
                <Field label="Food For Driver" value={val("foodfordriver")} />
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

/* ---------- reusable field ---------- */
function Field({ label, value }) {
  return (
    <div className="flex">
      <div className="w-[160px] font-semibold">{label}</div>
      <div className="w-[20px] text-center">:</div>
      <div className="flex-1">{value || ""}</div>
    </div>
  );
}